<mat-toolbar class="bg-gradient-to-r from-[#057EC9] to-[#02B4C7] text-white shadow-sm px-4 sm:px-6 py-2 flex items-center justify-between" *ngIf="isLogged">

  <!-- === VISTA DESKTOP === -->
  <ng-container *ngIf="!isMobile; else mobileToolbar">
    <!-- IZQUIERDA: menú + título -->
  <div class="flex items-center gap-4">
      <!-- Botón menú lateral (opcional) -->
      <!--
      <button mat-icon-button (click)="onToggleSidenav()">
        <mat-icon>menu</mat-icon>
      </button>
      -->

      <!-- Logo + menú principal (sin texto) -->
      <div class="text-[20px] font-bold text-white">
        <div class="flex flex-row items-center gap-5 ml-2">
          <a routerLink="/admin/home" class="flex items-center">
            <img src="assets/imgs/logo-la-soberania-2.png" alt="La Soberanía de Seguros" class="h-14 sm:h-20"/>
          </a>
          <div class="flex items-center cursor-pointer" [matMenuTriggerFor]="mainMenu">
            <img src="assets/svg/puntos-cuadricula-menu.svg" alt="Menú" />
          </div>
        </div>
      </div>
    </div>

    <!-- DERECHA: Botón principal -->
    <div class="flex items-center gap-2">
        <div class="flex items-center gap-4">
    <!-- Ícono de usuario predeterminado -->
    <button [matMenuTriggerFor]="accountMenu" class="p-2 hover:bg-white/10 rounded text-white">
      <div class="flex flex-row gap-2 h-[15px]">
        <div class="flex items-center text-[15px] text-white">
          {{nombre}}
        </div>
        <div class="flex items-center">
          <img src="assets/svg/icon-dropdown-toolbar.svg" class="w-3 h-3">
        </div>
      </div>
    </button>
        </div>
    </div>
  </ng-container>

  <!-- === VISTA MÓVIL === -->
  <ng-template #mobileToolbar>
    <!-- IZQUIERDA: logo -->
  <div class="flex items-center gap-2 text-white">
    <img src="assets/imgs/logo-la-soberania-2.png" alt="Logo" class="h-14 sm:h-20"  [routerLink]="'/admin/home'"/>
  </div>

    <!-- DERECHA: botones con íconos -->
    <div class="flex items-center gap-2">
      <!--<app-btn color="cancelBordeadoGray" >
        <img src="assets/svg/search-svg-mobile.svg" class="w-5 h-5" alt="Notificaciones" />
      </app-btn>-->

      <app-btn color="brand-gradient">
        + Crear
      </app-btn>

      <app-btn color="cancelBordeadoGray" [matMenuTriggerFor]="accountMenu">
        <img src="assets/svg/dots.svg" class="w-5 h-5" alt="Cerrar sesión" />
      </app-btn>
    </div>
  </ng-template>
</mat-toolbar>


  <!-- Menú desplegable del usuario -->
  <mat-menu #accountMenu="matMenu" class="w-[250px] flex flex-row">
      <button class="px-2.5 py-1 w-full hover:bg-gray-200 flex gap-2 items-center" routerLink="/admin/home" *ngIf="idRolUsuario == 1">
        <img src="assets/svg/home-menu.svg" class="w-[24px] h-[24px]">
      <span class="text-[15px] text-gray-700">Inicio</span>
    </button>
      <button [routerLink]="'/account/profile/my-account'"  class="px-2.5 py-1 w-full hover:bg-gray-200 flex gap-2 items-center">
        <img src="assets/svg/profile-icon.svg" class="w-[24px] h-[24px]">
      <span class="text-[15px] text-gray-700">Perfil</span>
    </button>
      <button  *ngIf="idRolUsuario == 1" routerLink="/admin/ajustes"  class="px-2.5 py-1 w-full hover:bg-gray-200 flex gap-2 items-center">
        <img src="assets/svg/ajustes-menu.svg" class="w-[24px] h-[24px]">
      <span class="text-[15px] text-gray-700">Ajustes</span>
    </button>

      <button *ngIf="idRolUsuario == 1"  routerLink="/admin/parametros"   class="px-2.5 py-1 w-full hover:bg-gray-200 flex gap-2 items-center">
        <img src="assets/svg/parametros.svg" class="w-[24px] h-[24px]">
      <span class="text-[15px] text-gray-700">Parámetros</span>
    </button>
    <button (click)="onLogout()"  class="px-2.5 py-1 w-full hover:bg-gray-200 flex gap-2 items-center">
        <img src="assets/svg/logout-menu.svg" class="w-[24px] h-[24px]">
      <span class="text-[15px] text-gray-700">Cerrar Sesión</span>
    </button>
  </mat-menu>

  <mat-menu #mainMenu="matMenu" class="w-[250px] flex flex-row">
      <button class="px-2.5 py-1 w-full hover:bg-gray-200 flex gap-2 items-center" routerLink="/admin/contratos-global" *ngIf="idRolUsuario == 1">
        <img src="assets/svg/formatos-garantias.svg" class="w-[24px] h-[24px]">
      <span class="text-[15px] text-gray-700">Reporte General de Ventas</span>
    </button>
  </mat-menu>